module.exports = __webpack_public_path__ + "static/media/twitter.543131f2.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/twitter.svg
// module id = 238
// module chunks = 0